import React from "react";
import s from './Users.module.scss'
import { NavLink } from "react-router-dom";

const User = ({ user, followingInProgress, getUnFollow, getFollow }) => {
  return (
    <div className={s.user}>
      <div className={s.userAvatar}>
        <NavLink to={`/profile/${user.id}`}>
          <img src={user.photos.small !== null ? user.photos.small : 'https://inlnk.ru/4yPn6P'} alt='avatar' />
        </NavLink>
        {user.isOnline ? <span className={s.userOnline}></span> : ''}
      </div>
      <div className={s.userInfo}>
        <span>{user.name}</span>
        <span>{user.status}</span>
      </div>
      <div className={s.userActions}>
        {
          !user.followed
            ? <button disabled={followingInProgress.some(id => id === user.id)}
              onClick={() => getFollow(user.id)}
              className={`${s.userBtn} ${s.userBtnAdd}`}>
            </button>
            : <button disabled={followingInProgress.some(id => id === user.id)}
              onClick={() => getUnFollow(user.id)}
              className={`${s.userBtn} ${s.userBtnDel}`}>
            </button>
        }
      </div>
    </div>
  );
}

export default User;